<template>
    <main>
       <section class="bg-white dark:bg-staticsecondary-900 ">
         <div class="container flex items-center justify-center min-h-screen w-full px-6 py-12">
           <div>
             <base-logo :filename="logo" alt="InvoiZE" class="mb-6"/>
             <h1 class="mt-3 text-2xl font-semibold text-staticsecondary dark:text-white md:text-3xl">{{ $t('app.redirecting') }}</h1>
           </div>
         </div>
       </section>
     </main>
   </template>

<script>
export default {
  /* eslint-disable camelcase */
  name: 'redirect-url',
  created () {
    if (this.nextRoute) {
      this.$router.replace(this.nextRoute)
    }
  },
  computed: {
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
    logo: function () {
      if (this.darkMode) {
        return 'logo-invoize-dark.svg'
      }
      return 'logo-invoize.svg'
    },
    nextRoute: function () {
      try {
        const route = this.$route.query.route
        if (route) {
          return JSON.parse(decodeURIComponent(route))
        }
      } catch {}
      return null
    }
  },
}
</script>

<style>

</style>
